// Utils
import { isBoard } from './elementTypeUtils';
import { buildPhysicalIdToVirtualIdMap } from './elementGraphUtils';
import { getElementId, getLocationParentId } from './elementPropertyUtils';

// Types
import { ImMNElementMap, MNElement } from '../elementModelTypes';
import { IdGraph, PhysicalParentGraph } from '../../dataStructures/graphTypes';

export const buildBoardHierarchies = (elements: MNElement[] | ImMNElementMap): IdGraph => {
    // First map all column IDs to their parent board IDs
    const result = buildPhysicalIdToVirtualIdMap(elements) as {
        columnIdToParentBoardIdMap: PhysicalParentGraph;
        elementIdToVirtualParentIdsMap: IdGraph;
    };

    const columnIdToParentBoardIdMap = result.columnIdToParentBoardIdMap;
    const elementIdToVirtualParentIdsMap = result.elementIdToVirtualParentIdsMap;

    return elements.reduce<IdGraph>((boardHierarchies: IdGraph, element) => {
        if (!isBoard(element)) return boardHierarchies;

        const elementId = getElementId(element);
        const parentIds = elementIdToVirtualParentIdsMap[elementId] || [getLocationParentId(element)];

        boardHierarchies[elementId] = parentIds.map(
            (parentId: string) => columnIdToParentBoardIdMap[parentId] || parentId,
        );

        return boardHierarchies;
    }, {});
};
